import { ReactNode } from 'react'
import styles from './sidebar.module.css'

export const SidebarTitle = ({ className, title, steps } : {
    className?: string
    title: string
    steps?: string
}) => {
    return <header className={`${className ?? ''} ${styles.sidebarTitle}`}>
        <span className={styles.sbTitleText}>{title}</span>
        { steps ? <span className={styles.sbTitleSteps}>{steps}</span> : null }
    </header>
}

export const Sidebar = ({ className, children }: {
    className?: string
    children?: ReactNode
}) => {
    return <section className={`${className ?? ''} ${styles.sidebar}`}>
        { children }
    </section>
}

export const SidebarScrollable = ({ children }: {
    children?: ReactNode
}) => {
    return <div className={styles.sbScrollable}>
        { children }
    </div>
}

export const SidebarFixed = ({ className, children }: {
    className?: string
    children?: ReactNode
}) => {
    return <div className={`${className ?? ''} ${styles.sbFixed}`}>
        { children }
    </div>
}